'use strict';

import * as d3 from 'd3';

const defaultBoundaries = {
  margin: { top: 20, right: 30, bottom: 40, left: 90 },
  width: 360,
  height: 200
};

class HistogramGraph {
  constructor(graphElement, dataset, boundaries = defaultBoundaries) {
    this.graph = {
      // set the dimensions and margins of the graph
      margin: boundaries.margin,
      width: boundaries.width - boundaries.margin.left - boundaries.margin.right,
      height: boundaries.height - boundaries.margin.top - boundaries.margin.bottom,
      dataset,
      graphElement
    };
  }

  updateDataset(dataset) {
    this.graph.dataset = [...dataset];
    this.remove();
    this.render();
  }

  remove() {
    d3.select(this.graph.graphElement)
      .selectAll('svg')
      .remove();
  }

  render() {
    // Get max domain range in steps of 10
    const max = this.graph.dataset.reduce(function(prev, current) {
      return prev && prev.value > current.value ? prev : current;
    }).value;
    const maxDomain = Math.ceil((max || 1) / 10) * 10;
    const maxLabelLength = 12;

    // append the svg object to the body of the page
    const svg = d3
      .select(this.graph.graphElement)
      .append('svg')
      .attr('width', this.graph.width + this.graph.margin.left + this.graph.margin.right)
      .attr('height', this.graph.height + this.graph.margin.top + this.graph.margin.bottom);

    const g = svg.append('g').attr('transform', `translate(${this.graph.margin.left} ${this.graph.margin.top})`);

    // Add X axis
    const x = d3
      .scaleLinear()
      .domain([0, maxDomain])
      .range([0, this.graph.width]);

    g.append('g')
      .classed('x-axis', true)
      .attr('transform', `translate(0, ${this.graph.height})`)
      .call(d3.axisBottom(x))
      .selectAll('text')
      .attr('transform', 'translate(-10,0)rotate(-45)')
      .style('text-anchor', 'end');

    // Y axis
    const y = d3
      .scaleBand()
      .range([0, this.graph.height])
      .domain(
        this.graph.dataset
          .map(function(d) {
            return d.name;
          })
          .sort()
      )
      .padding(0.1);

    g.append('g')
      .classed('y-axis', true)
      .call(d3.axisLeft(y).tickPadding(10))
      .selectAll('text')
      .style('transform', 'translateX(-60px)')
      .attr('text-anchor', 'start')
      .text(function(d) {
        return d.length > maxLabelLength ? d.substr(0, maxLabelLength) + '...' : d;
      })
      .append('title')
      .text(function(d) {
        return d;
      });

    // Bars
    svg
      .selectAll('myRect')
      .data(this.graph.dataset)
      .enter()
      .append('rect')
      .attr('x', this.graph.margin.left + 1)
      .attr('y', function(d) {
        return y(d.name);
      })
      .attr('width', function(d) {
        return x(d.value);
      })
      .attr('height', y.bandwidth())
      .attr('fill', '#69b3a2')
      .style('transform', 'translateY(20px)')
      .append('title')
      .text(function(d) {
        return d.name + ': ' + d.value;
      });
  }
}

export default HistogramGraph;
